export default __webpack_public_path__ + "static/013-a04c7609569414816211b44d2e50d1c5.jpg";